import clsx from "clsx";
import { Col, Row } from "react-bootstrap";
import * as dashboardSelectors from "../../selectors/dashboard";
import CustomPriceSpan from "../CustomPriceSpan";
import {
  getDashboardClientBranchCode, getDashboardContraGainAmount, getDashboardContraLossAmount,
  getDashboardCurrencyCodeSymbol,
  getDashboardFullCds, getDashboardInterestAmount,
  getDashboardNetBalanceAmount,
  getDashboardNetLossAmount,
  getDashboardNetTrustAmount,
  getDashboardRemisierCode,
  getDashboardTotalForceSaleAmount
} from "../../selectors/dashboard";
import { Tooltip as ReactTooltip } from "react-tooltip";
import { useRef } from "react";

function CustomCardInfo({ item, index }) {
  const tooltipsRef = useRef();

  const clientCode = dashboardSelectors.getDashboardClientCode(item);
  const clientName = dashboardSelectors.getDashboardClientName(item);
  const currencyCode = dashboardSelectors.getDashboardCurrencyCodeSymbol(item);
  const fullCds = dashboardSelectors.getDashboardFullCds(item);
  const clientBranchCode = dashboardSelectors.getDashboardClientBranchCode(item);
  const remisierCode = dashboardSelectors.getDashboardRemisierCode(item);
  const remisierName = dashboardSelectors.getDashboardRemisierName(item);

  const netTrust = dashboardSelectors.getDashboardNetTrustAmount(item);
  const netLoss = dashboardSelectors.getDashboardNetLossAmount(item);
  const netBalance = dashboardSelectors.getDashboardNetBalanceAmount(item);
  const trustMoney = dashboardSelectors.getDashboardTrustMoneyAmount(item);
  const salesProceedAmount = dashboardSelectors.getDashboardSalesProceedAmount(item);
  const purchasedContractAmount = dashboardSelectors.getDashboardPurchasedContractAmount(item);
  const contraGainAmount = dashboardSelectors.getDashboardContraGainAmount(item);
  const contraLossAmount = dashboardSelectors.getDashboardContraLossAmount(item);
  const interestAmount = dashboardSelectors.getDashboardInterestAmount(item);
  const otherBillsAmount = dashboardSelectors.getDashboardOtherBillsAmount(item);
  const forceSaleAmount = dashboardSelectors.getDashboardTotalForceSaleAmount(item);

  return (
    <div className="shadow mt-4">
      <div className={clsx("custom-card-label-container")}>
        <h2>
          Statement ({currencyCode})
        </h2>
      </div>
      <div className={clsx("custom-card-content-container")}>
        <Row>
          <Col md={6} lg={4} xl={3} sm={12}>
            <div className={clsx("custom-card-content-item-container")}>
              <h4>Trust</h4>
              <CustomPriceSpan value={trustMoney}></CustomPriceSpan>
            </div>
          </Col>
          <Col md={6} lg={4} xl={3} sm={12}>
            <div className={clsx("custom-card-content-item-container")}>
              <h4>Sales</h4>
              <CustomPriceSpan value={salesProceedAmount}></CustomPriceSpan>
            </div>
          </Col>
          <Col md={6} lg={4} xl={3} sm={12}>
            <div className={clsx("custom-card-content-item-container")}>
              <h4>Purchase</h4>
              <CustomPriceSpan value={purchasedContractAmount}></CustomPriceSpan>
            </div>
          </Col>
          <Col md={6} lg={4} xl={3} sm={12}>
            <div className={clsx("custom-card-content-item-container")}>
              <h4>Contra Gain</h4>
              <CustomPriceSpan value={contraGainAmount}></CustomPriceSpan>
            </div>
          </Col>

          <Col md={6} lg={4} xl={3} sm={12}>
            <div className={clsx("custom-card-content-item-container")}>
              <h4>Contra Loss</h4>
              <CustomPriceSpan value={contraLossAmount}></CustomPriceSpan>
            </div>
          </Col>
          <Col md={6} lg={4} xl={3} sm={12}>
            <div className={clsx("custom-card-content-item-container")}>
              <h4>Interest</h4>
              <CustomPriceSpan value={interestAmount}></CustomPriceSpan>
            </div>
          </Col>
          <Col md={6} lg={4} xl={3} sm={12}>
            <div className={clsx("custom-card-content-item-container")}>
              <h4>Others</h4>
              <CustomPriceSpan value={otherBillsAmount}></CustomPriceSpan>
            </div>
          </Col>
          <Col md={6} lg={4} xl={3} sm={12}>
            <div
              onClick={(e) => {
                if (forceSaleAmount > 0) {
                  tooltipsRef.current?.open({
                    position: {
                      x: e.clientX,
                      y: e.clientY,
                    },
                    place: "bottom",
                    content: "Need to do settlement today",
                  });
                }
              }}
              onMouseEnter={(e) => {
                if (forceSaleAmount > 0) {
                  tooltipsRef.current?.open({
                    position: {
                      x: e.clientX,
                      y: e.clientY,
                    },
                    place: "bottom",
                    content: "Need to do settlement today",
                  });
                }
              }}
              onMouseLeave={(e) => {
                tooltipsRef.current?.close();
              }}
              className={clsx("custom-card-content-item-container visually-hidden")}
            >
              <h4
                className={clsx({
                  ["negative-number"]: forceSaleAmount > 0,
                })}
              >
                Force Sell*
              </h4>
              <CustomPriceSpan value={forceSaleAmount}></CustomPriceSpan>
            </div>
          </Col>
        </Row>
      </div>
      <ReactTooltip ref={tooltipsRef} className="tooltip-info" variant="info"></ReactTooltip>
    </div>
  );
}

export default CustomCardInfo;
